import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { DeleteStatus, MasterDataStatus, OperationType, SharedService, UserType } from '../../shared/shared.service';;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import moment from 'moment';
import { ProxyDynamicService } from '../../shared/service/proxy-dynamic.service';
import { distinctUntilChanged, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-service-update-apartment-item',
  templateUrl: './update-apartment.component.html',
  styleUrl: './update-apartment.component.scss'
})
export class UpdateApartmentItemComponent implements OnInit, AfterViewInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  formGroup!: FormGroup;
  data: any = {};
  curentDate = moment().endOf('day').toDate();
  cancelSearchApartment = false;
  keywordApartment = '';
  listApartment: any[] = [];
  listApartmentByOwner: any[] = [];
  errorApartment: string = '';

  get f() {
    return this.formGroup.controls;
  }

  constructor(
    private modal: NzModalRef,
    private fb: FormBuilder,
    private sharedService: SharedService,
    private service: ProxyDynamicService,
    private translate: TranslateService
  ) {
    if (this.nzModalData.dataRow) {
      this.data = JSON.parse(JSON.stringify(this.nzModalData.dataRow));
    }
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      card_no: [null],
      owner: [null],
      old_apartment_ids: [null],
      new_apartment_ids: [null, Validators.required],
      note: [null]
    });

    this.service.findById('service_card', this.data.card_id).then((res: any) => {
      this.getDataApartment(res);
    });
  }

  ngAfterViewInit(): void {
    this.f['card_no'].disable();
    this.f['card_no'].setValue(this.data.card_no);
    this.f['owner'].disable();
    this.f['owner'].setValue(this.data.card_owner);
    this.f['old_apartment_ids'].disable();
    this.f['old_apartment_ids'].setValue(this.data.apartment_codes);

    // this.f['new_apartment_ids'].valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
    // this.errorApartment = '';
    // const validators = [Validators.required];
    // if (!value || value.length === 0) {
    // this.listApartment = [...this.listApartmentByOwner];
    // }
    //  else {
    //   const apartmentSelected = this.listApartmentByOwner.find((item: any) => item.id === value[0]);
    //   if (apartmentSelected) {
    //     if (apartmentSelected.operation_type === OperationType.OwnerManaged) {
    //       this.listApartment = this.listApartmentByOwner.filter((item: any) => item.operation_type === OperationType.OwnerManaged);
    //       if (value.length > 1) {
    // validators.push(Validators.maxLength(1));
    // this.errorApartment = this.translate.instant('service-card.error-choose-apartment');
    // }
    // } else if (apartmentSelected.operation_type === OperationType.SelfManaged) {
    //   this.listApartment = this.listApartmentByOwner.filter((item: any) => item.operation_type === OperationType.SelfManaged);
    // }
    // }
    // }  
    // this.f['new_apartment_ids'].setValidators(validators);
    // this.f['new_apartment_ids'].updateValueAndValidity();
    // })
  }

  destroyModal() {
    this.modal.destroy()
  }

  onSave() {
    if (this.formGroup.valid) {
      this.sharedService.showLoading(true);
      const apartment_ids = this.f['new_apartment_ids']?.value || [];
      const body = {
        apartment_ids,
        note: this.f['note'].value,
      };
      this.service.changeApartment(this.data.card_id, body).subscribe(() => {
        this.sharedService.showLoading(false);
        this.modal.destroy(true);
      }, (error: any) => {
        this.service.handleError(error)
        this.modal.destroy(false);
      });
    } else {
      this.sharedService.showLoading(false);
      Object.values(this.formGroup.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  getDataApartment(dataCard: any) {
    let query = {
      'status': { '_eq': MasterDataStatus.Active }, 'deleted': { '_eq': DeleteStatus.NO },
      ...(dataCard.user_type === UserType.Owner ? { 'owner': { '_eq': dataCard.owner_id } } : { 'butler_id': { '_eq': dataCard.butler_id } })
    }

    forkJoin({
      listApartmentByOwner: this.service.search('apartment', {
        filter: query,
        fields: ['id', 'code', 'operation_type']
      }),
      listApartmentActiveByCard: this.service.search('service_card_apartment', {
        filter: { 'service_card_id': { '_eq': dataCard.id }, 'deleted': { '_eq': DeleteStatus.NO } },
      })
    }).subscribe({
      next: ({ listApartmentByOwner, listApartmentActiveByCard }) => {
        if (listApartmentByOwner) {
          this.listApartmentByOwner = listApartmentByOwner.map((item: any) => ({
            ...item,
            text: item.code,
            value: item.id
          }));
          this.listApartment = this.listApartmentByOwner;
        }
        if (listApartmentActiveByCard) {
          this.f['new_apartment_ids'].setValue(listApartmentActiveByCard.map((item: any) => item.apartment_id));
        }
      },
      error: (error) => {
        this.service.handleError(error)
      }
    });
  }
}
